import { isLogged } from "@/utils/auth/user";

export function lazyLoadView(view) {
  return () => import(`@/views/${view}`);
}

export default [
  {
    path: "/",
    name: "login",
    component: lazyLoadView("authentication/Login.vue"),
    meta: {
      authRequired: false,
      layout: "PublicLayout",
    },
  },
  {
    path: "/login/:itoken",
    name: "ilogin",
    component: lazyLoadView("authentication/LoginImpersonate.vue"),
    meta: {
      authRequired: false,
    },
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: lazyLoadView("Dashboard.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/user",
    name: "user",
    component: lazyLoadView("user/User.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/user/add",
    name: "addUser",
    component: lazyLoadView("user/AddEditUser.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/user/edit/:id",
    name: "editUser",
    component: lazyLoadView("user/AddEditUser.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/customers",
    name: "customers",
    component: lazyLoadView("customer/Customer.vue"),
    meta: {
      authRequired: false,
    },
  },
  {
    path: "/subscriptions",
    name: "subscriptions",
    component: lazyLoadView("CommonComponent.vue"),
    meta: {
      authRequired: false,
    },
  },
  {
    path: "/commoncomponent",
    name: "commoncomponent",
    component: lazyLoadView("CommonComponent.vue"),
    meta: {
      authRequired: false,
    },
  },
  {
    path: "/customer",
    name: "Customer",
    component: lazyLoadView("customer/CustomerSteps.vue"),
    meta: {
      authRequired: true,
    },
    children: [
      {
        path: ":account_id?",
        name: "Company",
        component: lazyLoadView("customer/Company.vue"),
        meta: {
          authRequired: true,
        },
      },
      {
        path: "subscription/:account_id",
        name: "Subscription",
        component: lazyLoadView("customer/Subscription.vue"),
        meta: {
          authRequired: true,
        },
      },
    ],
  },
  {
    path: "/editcustomer",
    name: "EditCustomer",
    component: lazyLoadView("customer/EditCustomerSteps.vue"),
    meta: {
      authRequired: true,
    },
    children: [
      {
        path: ":account_id?",
        name: "EditCompany",
        component: lazyLoadView("customer/Company.vue"),
        meta: {
          authRequired: true,
        },
      },
      {
        path: "editsubscription/:account_id",
        name: "EditSubscription",
        component: lazyLoadView("customer/Subscription.vue"),
        meta: {
          authRequired: true,
        },
      },
    ],
  },
  {
    path: "/thankyou",
    name: "ThankYou",
    component: lazyLoadView("customer/ThankYou.vue"),
    meta: {
      authRequired: false,
      layout: "PublicLayout",
      background: "#f5f5f5",
    },
  },
  {
    path: "/payment",
    name: "Payment",
    component: lazyLoadView("customer/Payment.vue"),
    meta: {
      authRequired: false,
      layout: "PublicLayout",
      background: "#f5f5f5",
    },
  },
  {
    path: "/logout",
    name: "logout",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        // Before logging out, we can remove the user details from vuex/session.
        // store.dispatch("auth/logOut");
        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          (route) => route.meta.authRequired
        );
        // Navigate back to previous page, or home as a fallback
        next(authRequiredOnPreviousRoute ? { name: "user" } : { ...routeFrom });
      },
    },
  },
  {
    path: "/forgot-password",
    name: "forgotpassword",
    component: lazyLoadView("authentication/ForgotPassword.vue"),
    meta: {
      authRequired: false,
      layout: "PublicLayout",
    },
  },
  {
    path: "/change-password",
    name: "changepassword",
    component: lazyLoadView("authentication/ChangePassword.vue"),
    meta: {
      authRequired: true,
      // layout: "PublicLayout",
    },
  },
  {
    path: "/reset-password",
    name: "resetPassword",
    component: lazyLoadView("authentication/ResetPassword.vue"),
    meta: {
      authRequired: false,
      layout: "PublicLayout",
    },
  },
  {
    path: "/create-password",
    name: "createPassword",
    component: lazyLoadView("authentication/CreatePassword.vue"),
    meta: {
      authRequired: false,
      layout: "PublicLayout",
      hasBackGroundImage: false,
      background: "#ff9b44",
    },
  },
  {
    path: "/subscription-master",
    name: "SubscriptionMaster",
    component: lazyLoadView("subscription/Subscription.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/404",
    name: "404",
    component: require("@/views/_404.vue").default,
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true,
    meta: {
      layout: isLogged() ? "AuthLayout" : "PublicLayout",
      hasBackGroundImage: false,
      background: "#F5F5F5",
    },
  },
  {
    path: "/error",
    name: "error",
    component: require("@/views/_404.vue").default,
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true,
    meta: {
      layout: isLogged() ? "AuthLayout" : "PublicLayout",
      hasBackGroundImage: false,
      background: "#F5F5F5",
    },
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: "*",
    redirect: "404",
  },
];
